import React from 'react'
import { useTranslation } from 'react-i18next'
import { ToggleContainer, ToggleButton } from './PriceModeToggle.styles'
import type { PriceModeToggleProps, PriceMode } from './PriceModeToggle.types'

export const PriceModeToggle: React.FC<PriceModeToggleProps> = ({
  mode,
  onModeChange,
  className,
  disabled = false,
}) => {
  const { t } = useTranslation()

  const options: Array<{ value: PriceMode; labelKey: string }> = [
    { value: 'monthly', labelKey: 'common.priceMode.monthly' },
    { value: 'yearly', labelKey: 'common.priceMode.yearly' },
  ]

  return (
    <ToggleContainer className={className}>
      {options.map((option) => (
        <ToggleButton
          key={option.value}
          $active={mode === option.value}
          onClick={() => onModeChange(option.value)}
          disabled={disabled}
          type="button"
        >
          {t(option.labelKey)}
        </ToggleButton>
      ))}
    </ToggleContainer>
  )
}
